import { render, staticRenderFns } from "./vPopup.vue?vue&type=template&id=25b8c46f&scoped=true"
import script from "./vPopup.vue?vue&type=script&lang=ts"
export * from "./vPopup.vue?vue&type=script&lang=ts"
import style0 from "./vPopup.vue?vue&type=style&index=0&id=25b8c46f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b8c46f",
  null
  
)

export default component.exports